import { render, staticRenderFns } from "./SerialNo.vue?vue&type=template&id=3b3f3bb7&scoped=true&"
import script from "./SerialNo.vue?vue&type=script&lang=js&"
export * from "./SerialNo.vue?vue&type=script&lang=js&"
import style0 from "./SerialNo.vue?vue&type=style&index=0&id=3b3f3bb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3f3bb7",
  null
  
)

export default component.exports